<template>
	<div class="SystemQuestionBank">
		<div class="body">
			<div class="title-box">
				<span class="title">{{$t('QuesLibrary.QuestionBankList')}}</span>
				<span class="num">{{$t('QuesLibrary.NumberOfRecords')}}: {{ total }}</span>
				<span :title="$t('QuesLibrary.Refresh')" @click="refresh" class="el-icon-refresh-right"></span>
			</div>
			<div class="operation">
				<el-form :inline="true" :model="formItem" class="demo-form-inline">
					<el-form-item><el-input size="small" v-model="formItem.name" :placeholder="$t('QuesLibrary.SearchQuestionBankName')"></el-input></el-form-item>
					<el-form-item><el-input size="small" v-model="formItem.type" :placeholder="$t('QuesLibrary.SearchQuestionBankCategories')"></el-input></el-form-item>
					<el-form-item><el-button size="small" type="primary" @click="onSerach">{{$t('QuesLibrary.Query')}}</el-button></el-form-item>
				</el-form>
				<div>
					<el-button v-if="userInfo.usertype == 1" size="small" @click="setNewQuestionBank" type="primary">{{$t('QuesLibrary.CreateANewQuestionBank')}}</el-button>

					<el-button size="small" @click="batchDel" type="danger">{{$t('QuesLibrary.Delete')}}</el-button>
					<!-- <el-button size="small" @click="onCollection" type="primary">收藏</el-button> -->
				</div>
			</div>
			<el-table v-loading="tableLoading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" width="55"></el-table-column>

				<el-table-column align="center" :label="$t('QuesLibrary.QuestionBankNumber')" width="120">
					<template slot-scope="scope">
						<span>{{ scope.row.quesNo ? scope.row.quesNo : $t('QuesLibrary.None') }}</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="name" :label="$t('QuesLibrary.QuestionBankName')" width="120"></el-table-column>

				<el-table-column align="center" prop="type" :label="$t('QuesLibrary.QuestionBankCategory')"></el-table-column>

				<el-table-column align="center" prop="createName" :label="$t('QuesLibrary.Creator')"></el-table-column>

				<el-table-column align="center" prop="num" :label="$t('QuesLibrary.NumberOfTestQuestions')"></el-table-column>
				<el-table-column align="center" :label="$t('QuesLibrary.Memo')" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.remark ? scope.row.remark : $t('QuesLibrary.None') }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="address" width="300" :label="$t('QuesLibrary.Operate')">
					<template slot-scope="scope">
						<el-link v-if="scope.row.num == 0" @click="myCreated(scope.row)" type="primary" :underline="false">{{$t('QuesLibrary.CreateQuestion')}}</el-link>
						<el-link v-else @click="myEditQues(scope.row)" type="primary" :underline="false">{{$t('QuesLibrary.EditQuestion')}}</el-link>
						<el-link @click="myEditBank(scope.row)" type="primary" :underline="false">{{$t('QuesLibrary.EditQuestionBank')}}</el-link>
						<el-link @click="toPreview(scope.row)" type="primary" :underline="false">{{$t('QuesLibrary.Preview')}}</el-link>
						<el-popconfirm
							:append-to-body="false"
							placement="left"
							style="margin-left: 10px;"
							class="popconfirm"
							:title="$t('QuesLibrary.ConfirmDeletionOfQuestionBank')"
							@confirm="myDelete(scope.row)"
						>
							<el-link slot="reference" type="primary" :underline="false">{{$t('QuesLibrary.Delete')}}</el-link>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<div class="page-box"><el-pagination background layout="prev, pager, next" :page-size="pageSize" @current-change="currentChange" :total="total"></el-pagination></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SystemQuestionBank',
	components: {},
	data() {
		return {
			formItem: {
				name: '',
				type: ''
			},
			tableData: [],
			total: 0,
			pageSize: 10,
			pageIndex: 1,
			multipleSelection: [],
			tableLoading: false
		};
	},
	computed: {
		userInfo() {
			return JSON.parse(window.localStorage.getItem('userInfo'));
		}
	},
	created() {
		this.getData();
	},
	methods: {
		batchDel() {
			let arr = [];
			if (this.multipleSelection.length == 0) {
				this.$message({
					message: this.$t('QuesLibrary.SelectTheQuestionBankToDelete'),
					type: 'warning'
				});
				return;
			}
			this.multipleSelection.forEach(info => {
				arr.push(info.id);
			});

			let that = this;
			this.$confirm(this.$t('QuesLibrary.DeletSelectedQuestionBank'), this.$t('QuesLibrary.Prompt'), {
				confirmButtonText: this.$t('main.ok'),
				cancelButtonText: this.$t('main.cancel'),
				type: 'warning'
			})
				.then(() => {
					that.saveMyDelApi(arr);
				})
				.catch(() => {});
		},
		myCreated(item) {
			// 创建试题
			this.$router.push({
				path: '/addTestQuestionsWJ',
				query: {
					bankId: item.id,
					title: item.name,
					depict: item.remark,
					back: 5
				}
			});
		},
		myEditQues(item) {
			// 编辑试题
			this.$router.push({
				path: '/addTestQuestionsWJ',
				query: {
					bankId: item.id,
					title: item.name,
					depict: item.remark,
					isEdit: true,
					back: 5
				}
			});
		},
		myEditBank(item) {
			// 编辑题库
			this.$router.push({
				path: '/addQuestionBankWJ',
				query: {
					bId: item.id,
					isSystem: 1,
					back: 5,
					bankType: 1
				}
			});
		},
		myDelete(item) {
			let arr = [item.id];
			this.saveMyDelApi(arr);
		},
		saveMyDelApi(ids) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankDel}?ids=${ids}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.getData();
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		getData() {
			this.tableLoading = true;
			let that = this;
			let data = this.$qs.stringify({
				isSystem: 1, // 0自建题库 1系统题库
				name: this.formItem.name,
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
				bankType: 1,
				type: this.formItem.type // 题库类别
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankList}?${data}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					that.tableLoading = false;
					if (res.code == '0') {
						that.tableData = res.resultBody.datas;
						that.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.total = 0;
					}
				}
			};
			this.$util.request(params);
		},
		setNewQuestionBank() {
			this.$router.push({
				path: '/addQuestionBankWJ',
				query: {
					isSystem: 1,
					back: 5,
					bankType: 1
				}
			});
		},
		refresh() {
			this.pageIndex = 1;
			this.formItem = {
				name: '',
				type: ''
			};
			this.getData();
		},
		onSerach() {
			this.pageIndex = 1;
			this.getData();
		},
		onCollection() {
			// 收藏
			let arr = [];
			if (this.multipleSelection.length == 0) {
				this.$message({
					message: this.$t('QuesLibrary.ChooseAQuestionBankToBookmark'),
					type: 'warning'
				});
				return;
			}
			this.multipleSelection.forEach(info => {
				arr.push(info.id);
			});
			this.onItemsColl(arr);
		},
		handleSelectionChange(val) {
			console.log(val);
			this.multipleSelection = val;
		},
		onItemColl(item) {
			let arr = [item.id];
			this.onItemsColl(arr);
		},
		onItemsColl(ids) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankAddCollect}?bankIds=${ids}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.getData();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		cancelItemColl(item) {
			let arr = [item.id];
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankCancelBank}?bankIds=${arr}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.$message({
							message: that.$t('QuesLibrary.CanceledSuccessfully'),
							type: 'success'
						});
						that.getData();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		toPreview(item) {
			// 预览
			// sessionStorage.setItem("examId", item.id);
			// this.$router.push({
			//     path: '/examPreview',
			//     query: {
			//         id: item.id,
			//         isBank: true
			//     }
			// })
			sessionStorage.setItem('wid', item.id);
			this.$router.push({
				path: '/preview',
				query: {
					id: item.id,
					isBank: true
				}
			});
		},
		currentChange(e) {
			this.pageIndex = e;
			this.getData();
		}
	}
};
</script>

<style lang="scss" scoped>
.SystemQuestionBank {
	.body {
        padding: 0 40px 20px 40px;
		.title-box {
			line-height: 42px;
			span {
				font-size: 12px;
				color: #a7a6a6;
			}
			.title {
				font-size: 14px;
				color: #696868;
			}
			span + span {
				margin-left: 10px;
			}
		}
		.operation {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
		.page-box {
			margin-top: 20px;
			text-align: center;
		}
		.popconfirm {
			margin-left: 10px;
		}
	}
	.el-icon-refresh-right {
		cursor: pointer;
	}
}
/deep/.el-table__body-wrapper,
/deep/.el-table {
	overflow: inherit;
}
</style>
